import loadableWithRetry from '../common/loadableWithRetry'

const Dedication = loadableWithRetry(() => import('./Dedication'))

export default Dedication;
